export default "__VITE_ASSET__331d2514__"